<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Create New Other Loan Status</h3>

        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit" ref="otherLoanStatusForm">
                <b-row>
                    <!-- FIELD STATUS -->
                    <b-col cols="12">
                        <b-form-group label="Status:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'statusName'"
                            >
                            <b-form-input
                                v-model="new_status.status_name"
                                type="text"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD STATUS TYPE -->
                    <b-col cols="12">
                        <b-form-group label="Status Type:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'statusType'"
                            >
                            <el-select v-model="new_status.status_type" placeholder="Select">
                                <el-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD SUB STATUS -->
                    <b-col cols="12">
                        <b-form-group label="Main Status:" v-if="new_status.status_type == 'sub'">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'mainStatus'"
                            >
                            <el-select v-model="new_status.status_parent" placeholder="Select">
                                <el-option
                                v-for="item in main_status"
                                :key="item.status_id"
                                :label="item.status"
                                :value="item.status_id"
                                >
                                </el-option>
                            </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
										<!-- FIELD TAT DAY -->
										<b-col cols="12" class="mb-0" :class="{'mb-0 d-none':new_status.tat_stop}">
											<b-form-group label="Tat Days:">
													<b-form-input
															v-model="new_status.tat_day"
															type="number"
															min=0
															></b-form-input>
											</b-form-group>
										</b-col>
										<b-col cols="12">
											<el-checkbox v-model="new_status.tat_stop" class="mb-4">Stop TAT Tracking</el-checkbox>
										</b-col>
										<b-col cols="12">
											<el-checkbox v-model="new_status.is_generate_commission" class="mb-4">Allow Generate Commission</el-checkbox>
										</b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Create</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Checkbox } from 'element-ui'
import { 
    notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'

export default {
    props:{
        create_new_other_loan_status: Boolean
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
    },
    created(){
        this.getMainStatus()
    },
    watch:{
        "new_status.status_type"(newVal){
            if(newVal == "main"){
                this.new_status.status_parent = ""
            }
        }
    },
    computed: {
        show: {
            get() {
                return this.create_new_other_loan_status;
            },
            set(newVal) {
                this.$emit('update:create_new_other_loan_status', newVal);
            },
        },
    },
    data() {
        return {
            new_status: {
                status_name: '',
                status_type: 'main',
                status_parent: '',
								tat_day:0,
								tat_stop:0,
								is_generate_commission:0
            },
            statusOptions: [{
                value: 'main',
                label: 'Main Status'
            }, {
                value: 'sub',
                label: 'Sub Status'
            }],
            main_status: []
        }
    },
    methods:{
        getMainStatus() {
            axios.get(services.lookup + 'other_loan_status?status_type=main', {headers: getHeader()})
            .then(res => {
                this.main_status = res.data.data
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        submit(){
            let form = new FormData()
            form.append('status',this.new_status.status_name)
            form.append('group',this.new_status.status_type)
            form.append('parent_id',this.new_status.status_parent)
            form.append('tat_day',this.new_status.tat_day)
            form.append('tat_stop',this.new_status.tat_stop ? 1 : 0)
						form.append('is_generate_commission',this.new_status.is_generate_commission ? 1 : 0)
            axios.post(services.lookup + 'other_loan_status', form, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Status</b> - Successfully Created.')
                this.$emit('closeModal', false)
                mainEventBus.$emit('refresh-status')
                this.getMainStatus()
                this.resetFormToNull(this.new_status)
                if(res.data.data.group == 'main'){
                    this.getMainStatus()
                }
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
     }
}
</script>